import { Component, OnInit, HostListener, Inject, PLATFORM_ID, ChangeDetectorRef  } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss']
})
export class OrderSummaryComponent implements OnInit {
  isDrawerOpen: boolean;
  isMobile: boolean = false;  
  private drawerSubscription: Subscription;
  // private cartSubscription: Subscription;
  orderSummary: [] = [];
  isOrder: boolean = false; 
  storeDetails = {};
  title = {}
  priceDetailsOpened: boolean[] = [];
  showSkeletonLoader: boolean;
  featureTags = {};

  
    constructor(
      public sharedDataService: SharedDataService,
      private apiService: ApiService,
      private activatedRoute: ActivatedRoute,
      @Inject(PLATFORM_ID) private platformId: Object,
      private cdr: ChangeDetectorRef
    ) {
      this.checkScreenSize();
    }
  
    ngOnInit(): void {
      this.featureTags = JSON.parse(sessionStorage.getItem("featureTags")); 
      this.storeDetails = this.activatedRoute.snapshot.data['store']['response']['data']['store'];
      this.drawerSubscription = this.sharedDataService.drawerState$.subscribe(state => {
        this.isDrawerOpen = state;
        this.getSaleOrdersDetails();
        this.setBodyScrollState();
      });      
      // this.cartSubscription = this.sharedDataService.cartResponse$.subscribe(state => {
      //   this.getOrderSummary();
      // });      
      // if(this.apiService.loggedIn()){
      //   if (isPlatformBrowser(this.platformId)) {
      //     this.getOrderSummary();
      //   }
      // }
      
      this.priceDetailsOpened = this.orderSummary.map(() => false);
    }

    getOrderSummary() {
      this.sharedDataService.getOrderData().then((res) => {
          if(res['status'] === 1){
            this.isOrder = true;
            this.orderSummary = res.orderSummary; 
            console.log(this.orderSummary);
            this.showSkeletonLoader = false;
          }else{
            this.isOrder = false;
            this.showSkeletonLoader = false;
          }
        }).catch((error) => {
          this.isOrder = false;
          this.showSkeletonLoader = false;
          console.error('Error fetching order summary:', error);
        });
    }
    
    ngOnDestroy() {
      if (this.drawerSubscription) {
        this.drawerSubscription.unsubscribe();
      }
      // if (this.cartSubscription) {
      //   this.cartSubscription.unsubscribe();
      // }
    }
  
    // Toggle Drawer Open/Close
    toggleDrawer(): void {
      this.isDrawerOpen = !this.isDrawerOpen;
      this.getSaleOrdersDetails();
      this.setBodyScrollState();
    }

    // Call SaleOrder Api when drawer open
    getSaleOrdersDetails(){
      if(this.isDrawerOpen){
        this.showSkeletonLoader = true;
        this.getOrderSummary();
      }
    }

    // Toggle Drawer Close
    closeDrawer() {
      this.isDrawerOpen = false;
      this.setBodyScrollState();
    }

    setBodyScrollState(){
      const body = document.body;
      if (this.isDrawerOpen) {
          body.classList.add('no-scroll');
      } else {
          body.classList.remove('no-scroll');
      }
    }

    // Toggle Price Detals Drawer Open/Close
    toggleDetails(index: number): void {
      this.priceDetailsOpened[index] = !this.priceDetailsOpened[index];
      this.cdr.detectChanges();
    }
  
    // Detect screen size changes
    @HostListener('window:resize', ['$event'])
    checkScreenSize(): void {
      this.isMobile = window.innerWidth <= 959; // Mobile breakpoint
    }

    onEditOrderNavigation(){
      // To remove no-scroll class from body tag
      this.isDrawerOpen = false;
      this.setBodyScrollState();
    }
}
